import React, { useState, useRef, useEffect } from 'react';
import {
  animationDurationToShowscoresPopup,
  animationDurationToMoveCorrectAnswer
} from "../../../config";
import { useParams } from 'react-router-dom';
import { updateStorage } from "../../../hooks/useStorage";
import { updateGameStorage } from "../../../hooks/useGameStorage";
import RightPart from '../../RightPart';
import LeftPart from './components/LeftPart';
import { getAnswers, getFisrtNumber, getAnswersArray, generateImages, getAnimationValues } from './Subtracting.styles';
import * as amplitude from '@amplitude/analytics-browser';
import { useUpdateReduxState } from "../../../hooks/useUpdateReduxState";
import { gameId } from "../../../hooks/getGameId";
import { calcGapY, getCoordinates } from './Subtracting.styles';
import {wongAnswersLimit} from "../../../config.js"


export const Subtracting = ({ state, handleOpenScore, count, handleUpdateProgress, answerSound, point, hint, subscription, onQuestionChange, handleTimerResult }) => {
  const allAnswer = useRef(getAnswers());
  const { name, gameName } = useParams();
  const gameCount = useRef(0);
  const [result, setResult] = useState('?');
  const [answer, setAnswer] = useState(allAnswer.current[gameCount.current]);
  const firstNumber = useRef(getFisrtNumber(answer));
  const secondNumber = useRef(firstNumber.current - answer);
  const [topValues, setTopValues] = useState(getAnimationValues(firstNumber.current));
  const copyVal = [...topValues];
  const answersArray = useRef(getAnswersArray(answer));
  const images = useRef(generateImages());
  const score = useRef(0);
  const [arr, setArr] = useState([])

  const updateState = useUpdateReduxState();

  useEffect(() => {
    amplitude.track(`${"subtract" + "_" + gameName.replace("_", " ") + "_start"}`)
  }, []);

  const checkAnswer = (event, type, val, h) => {
    if (event === 'mouseup') return;

    score.current += point * type;
    if (!subscription) {
      updateStorage(point * type);
    }
    if (h) {
      handleTimerResult(false);
      if (arr.length < wongAnswersLimit) arr.push(val)
      onQuestionChange?.(`${firstNumber.current}-${secondNumber.current}=[${arr}] hint`);
    } else {

      if (type && val === answer) {

        setArr(prev => {
          const finalArr = [...prev, val];

          if (prev.length === 0) {
            onQuestionChange?.(`${firstNumber.current}-${secondNumber.current}=${val}`);
          } else {
            onQuestionChange?.(
              `${firstNumber.current}-${secondNumber.current}=[${finalArr.join(',')}]`
            );
          }

          return finalArr;
        });

        handleTimerResult(true);
      }
      else if (!type && val !== answer) {
        setArr(prev => {
          if (prev.length < wongAnswersLimit) {
            return [...prev, val];
          }
          return prev;
        });

        return;
      }
      else if (!type && val === answer) {
        setArr(prev => {
          onQuestionChange?.(
            `${firstNumber.current}-${secondNumber.current}=[${prev.join(',')}]`
          );
          return prev;
        });

        handleTimerResult(false);
      }
    }
    ///
    setTopValues(copyVal);
    if (gameCount.current === count - 1) {
      if (subscription) {
        updateState({
          userId: localStorage.getItem('user'),
          profileId: JSON.parse(localStorage.getItem('profile'))?._id,
          game: name,
          score: score.current,
          id: gameId(name, gameName),
          collection: name,
        })
      } else {
        handleUpdateProgress();
        updateGameStorage(name, gameName, point * type, true);
      }
      setTimeout(() => handleOpenScore(), animationDurationToShowscoresPopup * 1000);
      localStorage.setItem(`${name + '_' + gameName + '_' + '_score'}`, score.current);
    } else {
      if (!subscription) {
        handleUpdateProgress();
        updateGameStorage(name, gameName, point * type, false);
      }

      setTimeout(() => {
        gameCount.current += 1
        const answer = allAnswer.current[gameCount.current];
        firstNumber.current = getFisrtNumber(answer);
        secondNumber.current = firstNumber.current - answer;
        setAnswer(answer);
        setTopValues(getAnimationValues(firstNumber.current));
        setResult('?');
        setArr([])
        answersArray.current = getAnswersArray(answer);

      }, animationDurationToMoveCorrectAnswer * 1000);
    }
  }

  return (
    <div className="w-full h-full flex justify-between relative z-30">
      <LeftPart
        state={state}
        answer={answer}
        result={result}
        topValues={topValues}
        image={images.current[gameCount.current]}
        firstNumber={firstNumber.current}
        secondNumber={secondNumber.current}
      />
      <RightPart
        hint={hint}
        state={state}
        answer={answer}
        checkAnswer={checkAnswer}
        answerSound={answerSound}
        answers={answersArray.current}
        getCoordinates={getCoordinates}
        calcGapY={calcGapY}
      />
    </div>
  )
}